import { isMobile } from "react-device-detect";
import GreyCheckIcon from "../../assets/icons/GreyCheckIcon.svg";
import PreviewControls from "./PreviewControls";

export const EventsPreviewScreen = ({
  eventTime,
  name,
  enableJoin,
  savePreferenceAndJoin,
}) => {
  const EVENTS_SCREEN_POINTS = [
    "Use a stable, high bandwidth internet network to join the event.",
    "Give the event your full focus to catch every valuable detail.",
    "Do not leave until the end, or you might miss out on valuable benefits.",
  ];

  return (
    <div className="h-screen w-screen bg-black flex flex-col items-center pt-14 overflow-hidden justify-center">
      <div className="fixed top-12 left-0 rounded-r-full bg-yocket-orange-700 text-white font-bold text-xs pl-2 pr-3 py-1.5">
        Yocket Exclusive Event
      </div>

      <div className="flex flex-col sm:flex-row items-center justify-center gap-12 mb-10 px-4">
        <img
          src="/events-preview-illustration.webp"
          alt="events"
          className="h-auto w-full max-w-[440px] rounded-lg"
        />
        {isMobile ? (
          <div className="space-y-8 absolute bottom-32">
            <p className="text-white font-bold w-fit mx-auto">
              Your Guide to Securing Top 100
              <br /> University Admits with Scholarships!
            </p>

            <div
              className="w-full px-5 py-3 rounded-xl border border-yocket-neutral-400 space-y-3"
              style={{
                background:
                  "radial-gradient(107.32% 141.42% at 0% 0%, rgba(255, 255, 255, 0.40) 0%, rgba(255, 255, 255, 0.00) 100%)",
              }}
            >
              <div className="flex items-center gap-2  text-white">
                <img
                  src="/svgs/broadcast.svg"
                  alt="timing"
                  height="20"
                  width="20"
                />
                <span className="text-xs font-bold">{eventTime}</span>
              </div>
              <div className="flex items-center gap-2 text-white">
                <img
                  src="/svgs/location-pin.svg"
                  alt="location"
                  height="20"
                  width="20"
                />
                <span className="text-xs font-bold">Here, Right Now</span>
              </div>
            </div>
          </div>
        ) : (
          <div className="w-full max-w-[600px] space-y-12">
            <div className="space-y-3">
              <p className="text-3xl font-bold text-yocket-neutral-0 tracking-[0.12px]">
                Your Guide to Securing Top 100 University Admits with
                Scholarships!
              </p>
              <p className="text-sm text-[#CED1D9]">
                Learn directly from industry experts at this exclusive event.
              </p>
            </div>
            <div className="text-sm text-[#CED1D9] space-y-3">
              <p>What to do and what not to do:</p>
              {EVENTS_SCREEN_POINTS.map(point => (
                <div className="flex items-center gap-2.5">
                  <img src={GreyCheckIcon} alt="check" height="20" width="20" />
                  <p>{point}</p>
                </div>
              ))}
            </div>
          </div>
        )}
      </div>

      <div
        className="fixed bottom-8 sm:bottom-12 w-full 
          flex gap-2.5 items-center justify-center px-4"
      >
        <button
          type="button"
          className="yocket-btn !py-3 !text-base w-[212px] sm:w-[312px]"
          disabled={!name || !enableJoin}
          onClick={savePreferenceAndJoin}
        >
          Join the Event
        </button>
        <PreviewControls
          enableJoin={enableJoin}
          savePreferenceAndJoin={savePreferenceAndJoin}
          enableVideoToggle={false}
        />
      </div>
    </div>
  );
};

export default EventsPreviewScreen;
